
import {InGameAchievement, UIGameAchievementController} from '../../../../shared/scripts/ui_game/ui_game_achievement/UIGameAchievementController'

export class UIWGameAchievementController extends UIGameAchievementController {
    protected getAchievementView(options: InGameAchievement) {
        const canvas = this.uiGameManager.canvasController
        const mapSectionWidth = canvas.appW - canvas.chatWidth
        const itemSize = this.uiGameManager.canvasController.itemSize
        const margin = itemSize * 0.12
        const w = itemSize * 4
        const x = mapSectionWidth - w - margin
        const y = mapSectionWidth - x - w
        const h = w * 0.3
        const avatarSize = itemSize * 0.4

        return this.createAchievementView(options, x, y, w, h, avatarSize)
    }
}
